export default __webpack_public_path__ + "static/media/Basketball.cccb764d.webp";